<template>
  <div id="poll-add-update">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-12">
            <div class="card" style="margin-bottom: 9px;">
              <div class="card-body">
                <input autocomplete="false" name="hidden" type="text" style="display:none;" />

                <div class="row">
                  <div class="form-group col-md-6">
                    <label>{{this.$t('event.table.title')}}</label>
                    <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                    <span class="error">
                      {{
                      $errorMessage("title", validationErrors)
                      }}
                    </span>
                  </div>
                  <div class="form-group col-md-6">
                    <label>{{this.$t('event.tags.whichSession')}}</label>
                    <el-select
                      v-model="form.sessionID"
                      :placeholder="$t('event.tags.allSessions')"
                      clearable
                      @clear="form.sessionID = null"
                    >
                      <el-option
                        v-for="item in $store.state.livesessions.items"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <span class="error">
                      {{
                      $errorMessage("title", validationErrors)
                      }}
                    </span>
                  </div>
                </div>

                <div class="row">
                  <div
                    class="col-md-12"
                    style="margin-bottom: 5px; display: flex; align-items: center; flex-direction: row; justify-content: space-between"
                  >
                    <h4 style="margin: 0">{{this.$t('event.table.responses')}}</h4>
                    <el-button @click="addAnswer" size="mini" type="primary">{{this.$t('event.buttons.addAnswer')}}</el-button>
                  </div>
                  <div class="col-md-12" style="margin-bottom: 15px;">
                    <draggable
                      handle=".handle"
                      class="list-group"
                      tag="ul"
                      v-model="form.answers"
                      v-bind="dragOptions"
                      @start="drag = true"
                      @end="drag = false"
                    >
                      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        <li
                          @keyup.enter="addAnswer"
                          class="list-group-item"
                          v-for="(element, index) in form.answers"
                          :key="index + 1"
                        >
                          <span
                            style="font-weight:bold; display:inline-block; margin-right:5px"
                          >{{ index + 1 }}.</span>
                          <el-input
                            :autofocus="index == form.answers.length - 1"
                            v-model="form.answers[index].title"
                            :ref="'answerInput' + index"
                            :placeholder="
                              $i18n.locale == 'tr' ? index + 1 + '.cevabınızı buraya yazın' : 'write your '+ (index + 1) +'.answer here'
                            "
                            :class="
                              form.answers.some(
                                (k, answerIndex) =>
                                  (k.title == form.answers[index].title &&
                                    answerIndex != index) ||
                                  form.answers[index].title == '' ||
                                  form.answers[index].title == null
                              )
                                ? 'has-error-input'
                                : ''
                            "
                          >
                            <i
                              v-if="index > 1"
                              class="fas fa-trash el-input__icon"
                              slot="suffix"
                              style="cursor: pointer"
                              @click="deleteAnswer(index)"
                            ></i>
                          </el-input>
                          <div
                            style="width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; cursor: grab"
                            class="handle"
                          >
                            <i class="el-icon-rank" style="font-size: 20px"></i>
                          </div>
                        </li>
                      </transition-group>
                    </draggable>
                  </div>
                </div>

                <div
                  class="col-md-12"
                  style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; padding: 0"
                >
                  <div v-if="form.id != null">
                    <el-popconfirm
                      @confirm="deleteItem"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.buttons.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('event.textbox.toDelete')"
                    >
                      <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t('event.table.delete') }}</el-button>
                    </el-popconfirm>
                  </div>
                  <div
                    class="text-right"
                    style="display: flex; flex: 1; align-items: center; justify-content: flex-end"
                  >
                    <el-button-group>
                      <el-button
                        type="warning"
                        @click="
                          $emit('closeMe');
                          showInfo = false;
                        "
                      >{{$t('event.buttons.close')}}</el-button>
                      <el-button type="success" @click="save">{{$t("event.buttons.save")}}</el-button>
                    </el-button-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="form.id != null"
      @click="showInfo = !showInfo"
      style="display: flex; width: 100%; align-items: center; justify-content: center; cursor: pointer; padding: 10px 0px"
    >
      <i :class="!showInfo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>
    <transition name="slide-fade">
      <ItemInfo :data="form" v-if="showInfo" />
    </transition>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import axios from "axios";
import ItemInfo from "./ItemInfo";
import GroupAddUpdate from "./GroupAddUpdate";
export default {
  components: { ItemInfo, GroupAddUpdate, draggable },
  name: "PollAddUpdate",
  props: ["data"],
  data() {
    return {
      form: {
        id: null,
        title: null,
        answers: [
          {
            oldTitle: null,
            title: null
          },
          {
            oldTitle: null,
            title: null
          }
        ]
      },
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      addGroupModal: false,
      drag: false
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  mounted() {
    this.$store.dispatch("getLiveSessions");
  },
  methods: {
    addAnswer() {
      this.form.answers.push({
        oldTitle: null,
        title: null
      });

      setTimeout(() => {
        Object.keys(this.$refs).map((item, index) => {
          if (index == this.form.answers.length - 1) {
            this.$refs[item][0].focus();
          } else {
            this.$refs[item][0].blur();
          }
        });
      }, 100);
    },
    deleteAnswer(index) {
      this.form.answers.splice(index, 1);
    },
    async itemAdded(id) {
      this.addGroupModal = false;
      await this.$store.dispatch("getGroups");
      this.form.groupID = id;
    },
    deleteItem() {
      var index = this.$store.state.polls.items.findIndex(
        k => k.id == this.form.id
      );
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },
    save() {
      var sameCount = 0;
      this.form.answers.map((item, index) => {
        if (
          this.form.answers.some(
            (k, kindex) => k.title == item.title && kindex != index
          )
        ) {
          if (sameCount == 0) {
            this.$message.error(
              this.$t('message.vote')
            );
            sameCount = 1;
          }
        }
      });

      this.validationErrors = [];
      if (sameCount == 0) {
        axios.post("poll/addorupdate", this.form).then(res => {
          this.validationErrors = res.data.validationErrors;
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            if (this.form.id == null) {
              this.$emit("itemAdded");
              this.form = {
                id: null,
                title: null,
                answers: [
                  {
                    oldTitle: null,
                    title: null
                  },
                  {
                    oldTitle: null,
                    title: null
                  }
                ]
              };
            } else {
              this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
              if (this.showInfo) {
                this.showInfo = false;
                setTimeout(() => {
                  this.showInfo = true;
                }, 350);
              }
            }
          }
        });
      }
    }
  },
  watch: {
    data: function(newVal) {
      this.showInfo = false;
      if (newVal != undefined && newVal != null) {
        this.form = this.data;
        this.validationErrors = [];
      } else {
        this.form = {
          id: null,
          title: null,
          answers: [
            {
              oldTitle: null,
              title: null
            },
            {
              oldTitle: null,
              title: null
            }
          ]
        };
      }
    },
    "form.groupID": function(newVal) {
      if (newVal == -1) {
        this.form.groupID = null;
        this.addGroupModal = true;
      }
    }
  },
  created() {
    if (this.data != undefined && this.data != null) {
      this.form = this.data;
    }
  }
};
</script>
<style>
.flip-list-move {
  transition: transform 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/PollAddUpdate.vue